import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Header = styled.h1`
    ${FONTS.H2};
    margin-top: 60px;
    @media (max-width: 460px) {
        margin-top: 30px;
    }
`;

export const SubHeader = styled.h3`
    ${FONTS.H3};
    margin-bottom: 25px;
`;

export const Container = styled.div`
    position: relative;
    margin: 0 auto;
    padding: 0;
    width: 100%;
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -49px;
    @media (max-width: 860px) {
        padding: 0 30px;
    }
    @media (max-width: 460px) {
        padding: 0 10px;
    }
`;

export const CardContainer = styled.div`
    max-width: 1460px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const Card  = styled.div`
    max-width: 25%;
    min-width: 340px;
    @media (max-width: 1665px) {
        min-width: 33.3%;
    }
    @media (max-width: 1279px) {
        min-width: 50%;
    }
    @media (max-width: 997px) {
        min-width: 100%;
    }
    @media (max-width: 859px) {
        min-width: 50%;
    }
    @media (max-width: 832px) {
        min-width: 100%;
    }
`;


export const BackgroundImage = styled.svg`
    display: block;
    position: absolute;
    z-index: 0;
    width: 60%;
    right: 0;
    bottom: 0;
    @media (max-width: 530px) {
        width: 100%;
    }
`;

export const PromoBlock = styled.div`
    display: flex;
    flex-direction: row;
    z-index: 2;
    margin-top: 100px;
    margin-bottom: 100px;
`;

export const PromoWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-right: 110px;
`;
